import type { FeaturedBadgeRule, FeaturedBadgeRuleFormValues } from "../../../models/rulesFeaturedBadge";
import { FEATURED_BADGE_STATES } from "../../../models/rulesFeaturedBadge";
import { GRUPS_RULES_TENANT_ID } from "../constants/rulesTenant";
import type { AdminRulesColumnDef, AdminRulesTabConfig } from "../types";
import {
  createDefaultFeaturedBadgeEntries,
  formatEventScopeLabel,
  formatThresholdDuration,
  toFormFeaturedBadgeTenantId,
  validateFeaturedBadgeForm,
} from "./featuredBadgeRuleHelpers";

export { formatEventScopeLabel } from "./featuredBadgeRuleHelpers";

export const formatThresholdLabel = (thresholdMinutes: number, slug: string): string => {
  const state = FEATURED_BADGE_STATES.find((item) => item.value === slug);
  return `${state ? state.label : slug} (Umbral: ${formatThresholdDuration(thresholdMinutes)})`;
};

export const mapFeaturedBadgeRuleToFormValues = (
  row: FeaturedBadgeRule,
  grupsTenantId?: string
): FeaturedBadgeRuleFormValues => ({
  tenantId: toFormFeaturedBadgeTenantId(row.tenantId, grupsTenantId),
  eventTypeId: row.eventTypeId ?? undefined,
  eventSubTypeId: row.eventSubTypeId,
  entries: [
    {
      key: `entry-${row.id}`,
      id: row.id,
      label: row.label,
      slug: row.slug,
      thresholdMinutes: row.thresholdMinutes,
      colorVariant: row.colorVariant ?? 1,
    },
  ],
  active: row.active,
});

export const featuredBadgeTabConfig: AdminRulesTabConfig<
  FeaturedBadgeRule,
  FeaturedBadgeRuleFormValues
> = {
  category: "featured-badge",
  label: "Badges destacados",
  enabled: true,
  customColumns: [
    {
      field: "eventTypeId",
      header: "Tipo / Subtipo",
      body: (row) => formatEventScopeLabel(row),
      sortable: true,
    },
    {
      field: "label",
      header: "Etiquetas",
      sortable: false,
    },
  ] satisfies AdminRulesColumnDef<FeaturedBadgeRule>[],
  inlineFormFields: [],
  getEmptyFormValues: () => ({
    tenantId: GRUPS_RULES_TENANT_ID,
    eventTypeId: undefined,
    eventSubTypeId: null,
    entries: createDefaultFeaturedBadgeEntries(),
    active: true,
  }),
  mapRowToFormValues: mapFeaturedBadgeRuleToFormValues,
  validateForm: validateFeaturedBadgeForm,
};
